
<template>
  <div>
    <v-card style="border-radius:12px">
      <v-card-title primary-title>
        <div class="headline mb-0">Item {{one_item.idx +1}}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-autocomplete 
              v-model="mksl"
              :loading="!allPL"
              :items="allPL? allPL.data.map(o=>o.attributes) : []"
              item-text="name"
              label="Qual é o local de retirada?"
              prepend-icon="mdi-domain"
              hide-no-data
              :rules="[rules.required]"
              return-object
            >
              <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="mksl.ppl">
            <v-autocomplete
              v-model="ppl"
              :items="mksl.ppl.data.map(o=>o.attributes)"
              item-text="product_name"
              label="Produto"
              prepend-icon="mdi-domain"
              hide-no-data
              :rules="[rules.required]"
              return-object
            >
              <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
            </v-autocomplete>
          </v-col>
          <v-col cols='12'>
            <div class="d-flex justify-space-around">
              <v-text-field v-money="money" v-model="one_item.sell_price" prepend-icon="mdi-magnify" prefix="R$" label="Nosso preço"></v-text-field>
              <v-text-field v-model="one_item.total_bags" prepend-icon="mdi-magnify" type="number" label="Qtd sacos"></v-text-field>
            </div>
            <template v-if="settings && settings.others">
              <div v-for="(other,idx) in settings.others" :key="'ot'+idx" class="d-flex align-center">
                <v-text-field v-model="other.name" prepend-icon="mdi-magnify" label="Nome concorrente"></v-text-field>
                <v-text-field v-money="money" :key="other.name+idx+other.value" v-model="other.sell_price" prepend-icon="mdi-magnify" prefix="R$" label="Valor Concorrente"></v-text-field>
                <v-btn text small icon color="error" @click="removeOther(idx)"><v-icon small>mdi-delete</v-icon></v-btn>
              </div>
            </template>
            <v-btn block text color="primary" @click="addOther()"> <v-icon left>mdi-plus</v-icon> concorrente </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn @click="unsetItem()" cancel></v-btn>
        <v-btn @click=" setSettings(); setItem()" save></v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import {VMoney} from 'v-money'

export default {
  directives: {money: VMoney},
  props: {
    one_item: {
      type: Object,
    },
    unsetItem: {
      type: Function,
    },
    setItem: {
      type: Function,
    },
    
  },
  data() {
    return {
      key: null,
      mksl: {},
      ppl: {},

      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },

      settings: {
        others: []
      },

      default_other: {
        name: 'Concorrente',
        sell_price: '0.00',
      },

      rules: {
        required: v => !!v || 'Campo é necessário',
        notZeroPercentage: v => (!!v && v != '0.00' && parseFloat(v) < 100) || 'Formato válido: "99.99"',
        notZero: v=> v != '0.00' || 'Não pode ser zero',
        email: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido',
        cpf: v => (v && v.length == 11) || 'CPF deve ser completo',
      },

      default_deal_item: {
        brand_id: null,
        brand_name: '',
        pickup_location_id: null,
        product_pickup_location_id: null,
        product_pickup_location_name: '',
        sell_price: '0.00',
        other_sell_price: '0.00',
        total_bags: 0
      },
    }
  },
  methods: {
    setSettings(){
      this.one_item.settings = {...this.settings}
      const sum = this.settings.others.reduce((acc, one) => acc + Number(one.sell_price), 0);
      let avg = (sum / this.settings.others.length) || 0;
      avg = Math.round(avg*100)/100
      this.one_item.other_sell_price = avg
    },
    setupDealItem(){
      if (!this.one_item.settings){
        this.one_item.settings = {}
      } else {
        let o = {...this.one_item}
        this.settings.others = [...this.settings.others, ...o.settings.others]
      }
      if (!this.one_item.settings.others){
        this.one_item.settings.others = [
          {...this.default_other}
        ]
      }
      
    },
    removeOther(idx){
      // console.log(idx);
      let deleted_item = this.settings.others.splice(idx, 1)
      // console.log({d: deleted_item[0]});
    },
    addOther(){
      this.settings.others = [ ...this.settings.others , {...this.default_other}]
    },
    setupSelected(){
      if (this.one_item.pickup_location_id){
        this.mksl = this.allPL.data.find(o=>Number(o.id) == Number(this.one_item.pickup_location_id)).attributes
        // console.log(this.mksl);
        
        if (this.one_item.product_pickup_location_id){
          this.ppl = this.mksl.ppl.data.find(o=>Number(o.id) == Number(this.one_item.product_pickup_location_id)).attributes
        }
      }
    },
    getPickupLocations() {
      if (!this.allPL){
        this.getSuppliers('pickup_locations').then(a=>{
          // console.log(this.one_item.brand_id);
          this.setupSelected()
        })
      } else {
        this.setupSelected()
      }
    },
    ...mapActions({
      getSuppliers: 'Supplier/index', //USAR PARA TODOS, PASSAR PARAMETROS
      // function: 'Module/action'
    })
  },
  mounted () {
    // console.log('mounted');
    this.setupDealItem()
    this.getPickupLocations()
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      allPL: state => state.Supplier.allMarkets,
        
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    mksl(nv,ov) {
      if (nv){
        this.one_item.pickup_location_id = nv.id
        this.one_item.brand_id = nv.brand_id
        this.one_item.brand_name = nv.brand_name
      } else if (nv == false){
      }
    },
    ppl(nv,ov) {
      if (nv){
        this.one_item.product_pickup_location_id = nv.id
        this.one_item.product_pickup_location_name = nv.product_name
        this.one_item.product_id = nv.product_id

        this.one_item.brand_product_name = `${this.one_item.brand_name} - ${this.one_item.product_pickup_location_name}`
      } else if (nv == false){
      }
    },
  },
}
</script>

<style scoped>

</style>